import SkinProfileModel, {
  RawSkinProfile,
  RawSkinProfileToAdd
} from "@/models/skin-profile";

export interface SkinProfile {
  id: string;
  storageDir: string;
  url: string;
  date: Date;
  feeling: string;
  sleep: string;
  skinType: string;
  skinTime: string;
  note: string;
}

export interface SkinProfileTextFields {
  feeling: string;
  sleep: string;
  skinType: string;
  skinTime: string;
  note: string;
}

export interface SkinProfileToAdd extends SkinProfileTextFields {
  storageDir: string;
  url: string;
}

export default class SkinProfileController {
  private phone: string;

  constructor(phone: string) {
    this.phone = phone;
  }

  public async fetchSkinProfilesByPhone(): Promise<SkinProfile[]> {
    const rawSkinProfiles: RawSkinProfile[] = await SkinProfileModel.fetchSkinProfilesByPhone(
      this.phone
    );
    const skinProfiles = this.cookRawSkinProfiles(rawSkinProfiles);
    return skinProfiles;
  }

  private cookRawSkinProfiles(
    rawSkinProfiles: RawSkinProfile[]
  ): SkinProfile[] {
    return rawSkinProfiles.map((rawSkinProfile) => {
      return {
        id: rawSkinProfile.id,
        storageDir: rawSkinProfile.storageDir,
        url: rawSkinProfile.url,
        date: new Date(rawSkinProfile.dateMsec),
        feeling: rawSkinProfile.feeling,
        sleep: rawSkinProfile.sleep,
        skinType: rawSkinProfile.skinType,
        skinTime: rawSkinProfile.skinTime,
        note: rawSkinProfile.note
      };
    });
  }

  public deleteSkinProfile(skinProfileId: string) {
    return SkinProfileModel.deleteSkinProfile(skinProfileId);
  }

  public addSkinProfile(skinProfile: SkinProfileToAdd) {
    const rawSkinProfileToAdd: RawSkinProfileToAdd = {
      ...skinProfile,
      dateMsec: new Date().getTime(),
      phone: this.phone
    };
    return SkinProfileModel.addSkinProfile(rawSkinProfileToAdd);
  }
}
